<template>
  <ion-list-header>
    <ion-label class="ion-text-uppercase">
      {{ t(label) }} {{ required ? '*' : '' }}
    </ion-label>
  </ion-list-header>
  <ion-radio-group
      v-model="value"
      :class="meta.validated && !meta.valid ? 'error' : ''"
  >
    <ion-item
        v-for="i in interests"
        :key="i.id"
    >
      <ion-label>{{ i.name }}</ion-label>
      <ion-radio
          slot="end"
          color="primary"
          :value="i.id"
      />
    </ion-item>
  </ion-radio-group>
  <div class="ion-text-right">
    <span class="error-text">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import { defineRule, useField } from 'vee-validate'
import { required } from '@vee-validate/rules'
import InterestRadio from '@/composables/InterestRadio'
import {
  IonLabel,
  IonListHeader,
  IonRadio,
  IonRadioGroup,
  IonItem,
} from '@ionic/vue'
import { useI18n } from "vue-i18n";

defineRule('required', required)

export default defineComponent({
  components: {
    IonLabel,
    IonListHeader,
    IonRadio,
    IonItem,
    IonRadioGroup,
  },
  props: {
    modelValue: {
      type: Number,
    },
    label: {
      type: String,
      default: 'Grupo de interes',
    },
    placeholder: {
      type: String,
      default: 'Seleccione un interes',
    },
    required: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n()
    const { interests } = InterestRadio()

    const { value, errorMessage, meta } = useField(
        'radio-button',
        { required: props.required },
        {
          initialValue: props.modelValue,
          label: t(props.label)
        },
    )

    watch(value, () => emit('update:modelValue', value.value))

    return {
      t,
      value,
      meta,
      interests,
      errorMessage,
    }
  },
})
</script>
